<template>
    <article class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
        <a
            :href="post.url"
            class="group rounded-3xl overflow-hidden bg-stone-100 min-h-80"
        >
            <Image
                :src="post.getCoverImageUrl()"
                :alt="post.title"
                class="w-full h-full object-cover"
            />
        </a>

        <div class="flex flex-col justify-center gap-4">
            <p class="text-sm uppercase tracking-[0.2em] text-gray-500">
                Featured post
            </p>
            <a
                :href="post.url"
                class="group"
            >
                <h2
                    class="text-3xl md:text-5xl font-semibold tracking-tight text-gray-900 group-hover:underline"
                >
                    {{ post.title }}
                </h2>
            </a>
            <p class="text-lg leading-8 text-gray-600">
                {{ post.excerpt }}
            </p>
            <div>
                <a
                    :href="post.url"
                    class="inline-flex items-center gap-2 text-sm font-medium text-gray-900"
                >
                    Read post
                    <span aria-hidden="true">→</span>
                </a>
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import Image from '@/Shared/Component/Image.vue'

    interface BlogFeaturedPostProps {
        post: CMSArticle
    }

    defineProps<BlogFeaturedPostProps>()
</script>
